/**
 * @module components\ghInput\numberInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";

@Component
export default class NumberInput extends InputBase {}
